import { supabase } from "./supabase";

/**
 * Sync the assignees for a crm_activity.
 *
 * Diffs the current set of assignees (in crm_activity_assignees) against
 * the desired set, inserting new ones and deleting removed ones.
 *
 * Newly-inserted rows have notified_at = null, which is the queue for
 * the future "send assignment email" job.
 */
export async function syncActivityAssignees(
  activityId: number,
  salesIds: number[],
): Promise<void> {
  // Fetch current
  const { data: current, error: fetchError } = await supabase
    .from("crm_activity_assignees")
    .select("sales_id")
    .eq("activity_id", activityId);

  if (fetchError) throw fetchError;

  const currentSet = new Set(
    (current ?? []).map((r: any) => Number(r.sales_id)),
  );
  const nextSet = new Set(salesIds.map(Number));

  const toAdd = [...nextSet].filter((id) => !currentSet.has(id));
  const toRemove = [...currentSet].filter((id) => !nextSet.has(id));

  if (toAdd.length > 0) {
    const { error } = await supabase.from("crm_activity_assignees").insert(
      toAdd.map((sales_id) => ({
        activity_id: activityId,
        sales_id,
        // notified_at left null: this is the signal for the email job
      })),
    );
    if (error) throw error;
  }

  if (toRemove.length > 0) {
    const { error } = await supabase
      .from("crm_activity_assignees")
      .delete()
      .eq("activity_id", activityId)
      .in("sales_id", toRemove);
    if (error) throw error;
  }
}
